'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import Description from './Items/Description';
import Contacts from './Items/Contacts';
import Slider from './Items/Slider';
import Address from './Items/Address';
import Price from './Items/Price';
import Area from './Items/Area';
import Building from './Items/Building';
import Land from './Items/Land';
import Controls from './Items/Controls';

class BaseFlexItem extends React.Component {
  constructor (props) {
    super(props);

    this.item = props.item;
    this.rawItem = props.rawItem;

    this.property = this.item.getProperty();
    this.location = this.property.getGeoLocation();
    this.room = this.property.getRoom();
    this.className = this.item.getServices().map(v => v.alias).join(' ');
  }

  render () {
    const {
      user,
      domain,
      onUpdateFilter,
      eventMapModal,
      eventAddFavorites,
      eventRemoveFavorites,
      eventOpenCommentForm,
      eventOpenClaimForm,
      eventShowContacts,
      eventClickAnnouncement,
      eventAddFavoritesForCian,
      eventRemoveFavoritesForCian
    } = this.props;
    return (
      <div onClick={() => eventClickAnnouncement(this.rawItem)} className={'realty-item ' + this.className}>
        <a className='link' href={this.item.getLink()} target='_blank'>
          <div className='flex-item__container'>
            <div className='flex-item flex-item__slider'>
              <Slider
                item={this.item}
                user={user}
              />
            </div>
            <div className='flex-item flex-item__properties'>
              <div className='properties__main-info'>
                <Address
                  item={this.item}
                  domain={domain}

                  eventMapModal={eventMapModal}
                />
                <Price
                  item={this.item}
                />
                <Area
                  item={this.item}
                />
                <Land
                  item={this.item}
                />
                <Building
                  item={this.item}
                />
              </div>
              <div className='properties__description'>
                <Description
                  item={this.item}
                  user={user}
                />
              </div>
              <div className='properties__controls'>
                <Controls
                  item={this.item}
                  rawItem={this.rawItem}
                  user={user}

                  eventAddFavorites={eventAddFavorites}
                  eventRemoveFavorites={eventRemoveFavorites}
                  eventAddFavoritesForCian={eventAddFavoritesForCian}
                  eventRemoveFavoritesForCian={eventRemoveFavoritesForCian}
                  eventOpenCommentForm={eventOpenCommentForm}
                  eventOpenClaimForm={eventOpenClaimForm}
                />
              </div>
            </div>
            <div className='flex-item flex-item__contacts'>
              <Contacts
                item={this.item}
                rawItem={this.rawItem}
                user={user}
                onUpdateFilter={onUpdateFilter}
                eventShowContacts={eventShowContacts}
              />
            </div>
          </div>
        </a>
      </div>
    );
  }
}

BaseFlexItem.propTypes = {
  item: PropTypes.object.isRequired,
  rawItem: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  domain: PropTypes.object.isRequired,

  onUpdateFilter: PropTypes.func.isRequired,

  eventAddFavorites: PropTypes.func,
  eventRemoveFavorites: PropTypes.func,
  eventOpenCommentForm: PropTypes.func,
  eventOpenClaimForm: PropTypes.func,
  eventMapModal: PropTypes.func,
  eventShowContacts: PropTypes.func,
  eventClickAnnouncement: PropTypes.func,
  eventAddFavoritesForCian: PropTypes.func,
  eventRemoveFavoritesForCian: PropTypes.func
};

BaseFlexItem.defaultProps = {
  eventAddFavorites: id => {},
  eventRemoveFavorites: id => {},
  eventOpenCommentForm: id => {},
  eventOpenClaimForm: id => {},
  eventMapModal: id => {},
  eventShowContacts: id => {},
  eventClickAnnouncement: id => {},
  eventAddFavoritesForCian: id => {},
  eventRemoveFavoritesForCian: id => {}
};

export default BaseFlexItem;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FlexItems/BaseFlexItem.jsx